import axios from 'axios'
import { authHeader } from '../_helpers'
import { cancelSource } from '../_helpers/cancelToken'

const state = {
  devices: [],
  loading: true,
  schemas: [],
  cards: []
}

const mutations = {
  getDevicesSuccess (state, data) {
    state.devices = data
    state.loading = false
  },
  getLoadingStart (state) {
    state.loading = true
  },
  getLoadingEnd (state) {
    state.loading = false
  },
  getCardsSuccess (state, data) {
    state.cards = data
  },
  getSchemasSuccess (state, data) {
    const schemas = []
    for (var d of data) {
      schemas.push({
        text: d.name,
        value: d.id
      })
    }
    state.schemas = schemas
  },
  getSchemasError () {

  }
}

const actions = {
  getSchemas ({ commit, dispatch }) {
    dispatch('alert/clear', null, { root: true })
    axios.get(process.env.VUE_APP_URL + 'accounts/api/devices/schemas', { headers: authHeader() })
      .then(responce => {
        commit('getSchemasSuccess', responce.data)
      })
      .catch(error => {
        commit('getSchemasError')
        dispatch('alert/error', 'Произошла ошибка: ' + error, { root: true })
      })
  },
  getCards ({ commit, dispatch }) {
    dispatch('alert/clear', null, { root: true })
    axios.get(process.env.VUE_APP_URL + 'accounts/api/devices/cards', { headers: authHeader() })
      .then(responce => {
        commit('getCardsSuccess', responce.data)
      })
      .catch(error => {
        dispatch('alert/error', 'Произошла ошибка: ' + error, { root: true })
      })
  },
  getDevices ({ commit, dispatch }) {
    dispatch('alert/clear', null, { root: true })
    cancelSource.cancel()
    cancelSource.setSource(axios.CancelToken.source())
    commit('getLoadingStart')
    axios.get(process.env.VUE_APP_URL + 'accounts/api/devices', { headers: authHeader(), cancelToken: cancelSource.getSource().token })
      .then(responce => {
        commit('getDevicesSuccess', responce.data)
        commit('getLoadingEnd')
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          return
        }
        var errorCode = error.response.status
        switch (errorCode) {
          // case 400:
          //   dispatch('alert/error', 'Произошла ошибка:' + ' Ошибка загрузки данных. Проверьте токен доступа системы топливных карт', { root: true })
          //   break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        commit('getLoadingEnd')
        dispatch('alert/error', 'Произошла ошибка: ' + error, { root: true })
      })
  },
  updateDevice ({ commit, dispatch }, device) {
    dispatch('alert/clear', null, { root: true })
    console.log(device)
    const requestBody = {
      petrolCardId: device.petrolCard !== null ? device.petrolCard.id.toUpperCase() : null,
      shellCardId: device.shellCard !== null ? device.shellCard.id.toUpperCase() : null,
      rosneftCardId: device.rnCard !== null ? device.rnCard.id.toUpperCase() : null,
      optiCardId: device.optiCard !== null ? device.optiCard.id.toUpperCase() : null,
      nesteCardId: device.nesteCard !== null ? device.nesteCard.id.toUpperCase() : null
    }
    axios.put(process.env.VUE_APP_URL + `accounts/api/devices/${device.id}`, requestBody, { headers: authHeader() })
      .then(responce => {
        dispatch('alert/success', 'Информация о ТС успешно обновлена', { root: true })
        dispatch('getDevices')
      })
      .catch(error => {
        commit('getLoadingEnd')
        dispatch('alert/error', 'Произошла ошибка: ' + error, { root: true })
      })
  }
}

export const device = {
  namespaced: true,
  state,
  mutations,
  actions
}
